/* Global constants
======================================== */
const
	$B = $('body'),
	$W = $('#wrapper'),
	isTouchDevice = () => {
		return(
			('ontouchstart' in window) ||
			(navigator.maxTouchPoints > 0) ||
			(navigator.msMaxTouchPoints > 0)
		);
	};
const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

/* Easing
======================================== */
const
	speed   = 300,
	speedx2 = speed*2,
	ease    = 'easeInOutQuint';

/* Init
======================================== */
function heightViewport(){
	document.documentElement.style.cssText = `
		--height-viewport: ${window.innerHeight}px;
		--rows_d: ${Math.trunc((window.innerHeight - 16 - 14)/(16))};
		--rows_t: ${Math.trunc((window.innerHeight - 12 - 10)/(16))};
		--rows_m: ${Math.trunc((window.innerHeight - 12 - 10)/(12))};
	`;
}

/* Section functions
======================================== */
function moveWrapper(target){
	closePopUp();
	if(!$W.hasClass('transition')){
		// closePopUp()
		$W.addClass('transition').attr('data-visible', target)
		setTimeout(function(){
			$W.removeClass('transition')
		}, speedx2);
	}
}
function moveWrapperLeft(visible){
	closePopUp();
	if(!$W.hasClass('transition')){
		$W.addClass('transition')
		if(window.innerWidth > 834){
			$W.attr('data-visible', 'menu')
		}else{
			// closePopUp()
			if(visible == 'cart'){
				$W.attr('data-visible', 'content')
			}else{
				$W.attr('data-visible', 'menu')
			}
		}
		setTimeout(function(){
			$W.removeClass('transition')
		}, speedx2);
	}
}
function moveWrapperRight(visible){
	closePopUp();
	if(!$W.hasClass('transition')){
		$W.addClass('transition')
		if(window.innerWidth > 834){
			// closePopUp()
			$W.attr('data-visible', 'cart')
		}else{
			// closePopUp()
			if(visible == 'menu'){
				$W.attr('data-visible', 'content')
			}else{
				$W.attr('data-visible', 'cart')
			}
		}
		setTimeout(function(){
			$W.removeClass('transition')
		}, speedx2);
	}
}

/* Scroll functions
======================================== */
const
	$main = $('main'),
	$specs = $('#product-specs');
var lastScrollTop = 0;
if($B.hasClass('template-product') && $specs.length){
	$main.scroll(function(){
		//Product specs
		if($specs.hasClass('virgin')){
			var t = $('#trigger-specs'),
				h = $main.scrollTop() + $main.innerHeight(),
				top = $main.scrollTop();
			if(top > lastScrollTop){
				if(h >= $main[0].scrollHeight && !$specs.is(':visible')){
					t.addClass('transition').addClass('active')
					$specs.slideDown(speedx2, ease, function(){
						t.removeClass('transition')
					});
					$main.animate({
						scrollTop: h
					}, speedx2, ease)
				}
			}else{
				if(h <= ($main[0].scrollHeight - $('#product-form').height()) && $specs.is(':visible')){
					t.addClass('transition').removeClass('active')
					$specs.slideUp(speedx2, ease, function(){
						t.removeClass('transition')
					});
				}
			}
			lastScrollTop = top;
		}
	})
}

/* Resize functions
======================================== */
window.onresize = function(){
	heightViewport()
}

/* Device detection
======================================== */
if (isMobile) {

	//If device
	$B.addClass('mobile');
	
	//Pseudoclass :active on devices
	document.addEventListener('touchstart', function(){}, {passive: true});

	//Swipe slider
	if(!$B.hasClass('template-index')){
		let tsX = 0,
				teX = 0;
		const p = document.getElementById('wrapper')
		p.addEventListener('touchstart', function(event){
			tsX = event.changedTouches[0].screenX;
		}, false);
		p.addEventListener('touchend', function(event){
			var visible = $W.attr('data-visible');
			teX = event.changedTouches[0].screenX;
			if(teX >= tsX && (teX - tsX > 60)){
				//Left
				moveWrapperLeft(visible)
			}
			if(teX <= tsX && (tsX - teX > 60)){
				//Right
				moveWrapperRight(visible)
			}
		}, false);
	}

}else{

	//if Desktop
	$B.addClass('desktop');

	//Navigation sections
	function checkKey(e){
		e = e || window.event;
		var visible = $W.attr('data-visible');
		if(e.keyCode == '37'){
			//Left
			moveWrapperLeft(visible)
		}else if(e.keyCode == '39'){
			//Right
			moveWrapperRight(visible)
		}
	}
	if (!$B.hasClass('template-index')) {
		document.onkeydown = checkKey;
	}

	//Shop
	$('.product').on('mouseenter', function(){
		var t = $(this);
		if(window.innerWidth > 834){
			$('.filter[data-filter="'+t.data('filter')+'"] wrap').html(t.find('.product-infos').html())
			$('.product').not(t).css('opacity', '.4');
		}
	}).on('mouseleave', function(){
		if(window.innerWidth > 834){
			$('.filter wrap').empty()
			$('.product').css('opacity', '1');
		}
	});

	//Scroll in main
	$('aside, #minicart-wrapper').bind('mousewheel', function(e){
		if(window.innerWidth > 834){
			$main.prop('scrollTop', Math.trunc($main.scrollTop() + e.originalEvent.wheelDelta/4.5*-1));
		}
	});

}

/* Loader
======================================== */
heightViewport()
setTimeout(function(){
	$('#loader').fadeOut(speed);
}, speed);

/* Language
======================================== */
if(localStorage.getItem('lang') === 'de'){
	document.documentElement.setAttribute('lang', 'de');
	$('#de').addClass('active').siblings().removeClass('active')
}
$('#language-switcher .trigger').click(function(e){
	var t = $(this),
		 id = t.attr('id');
	e.stopPropagation()
	t.addClass('active').siblings().removeClass('active')
	document.documentElement.setAttribute('lang', id);
	localStorage.setItem('lang', id);
})

/* Popups
======================================== */
const cookies = $('#cookies');
const contact = $('#contact');
const newsletter = $('#newsletter');

function closePopUp() {

	const popup = $('.popup-wrapper:visible').not(cookies);

	if (!$B.hasClass('transition') && popup.length) {

		$B.addClass('transition');
		$('.popup-trigger').removeClass('active');

		popup.slideUp(speedx2, ease, () => {
			popup.is(newsletter) && sessionStorage.setItem('popup-newsletter', false);
			resetPopUpForm(popup);
			$B.removeClass('transition');
		});

	}

}

function resetPopUpForm(popup) {
	const submit = popup.find('button');
	const message = popup.find('.module-form_message');
	if (submit.hasClass('success')) {
		submit.attr('disabled', false).removeClass('success').text(submit.val());
	}
	if (message.length) {
		message.remove();
		popup.find('input').val('');
	}
}

let counter = null;

function showNewsletterPopUp(timer) {
	if (newsletter.find('button').hasClass('success')) return;
	counter = setTimeout(() => {
		$('[data-popup="#newsletter"]').addClass('active');
		newsletter.slideDown(speedx2, 'easeInOutQuad');
	}, timer);
}

$('.popup-trigger').click(function (e) {

	const cta = $(this);
	const popup = $(cta.data('popup'));

	e.stopPropagation();
	counter && clearTimeout(counter), counter = null;

	if (!$B.hasClass('transition') && popup.length) {

		$B.addClass('transition');

		const active = $('.popup-wrapper:visible')
		if (active.not(popup).length) {

			$('.popup-trigger').removeClass('active');
			cta.addClass('active');
			active.slideUp(speedx2, ease, () => {
				active.is(newsletter) && sessionStorage.setItem('popup-newsletter', false);
				popup.slideDown(speedx2, ease, () => $B.removeClass('transition'));
			});

		} else {

			cta.toggleClass('active');
			popup.slideToggle(speedx2, ease, () => {
				if (popup.is(cookies)) {
					localStorage.setItem('cookies', true);
					newsletter.length && showNewsletterPopUp(2000);
				}
				popup.is(newsletter) && sessionStorage.setItem('popup-newsletter', false);
				$B.removeClass('transition');
			});

		}

	}

});

$('.popup-wrapper, [data-popup]').click(e => e.stopPropagation());
$('.popup-close').click(closePopUp);

!$B.hasClass('template-index') && $(document).click(closePopUp);

localStorage.getItem('cookies') == 'true' && cookies.remove();

if (newsletter.length) {
	if (!cookies.length || cookies.length && localStorage.getItem('cookies')) {
		if (!sessionStorage.getItem('popup-newsletter')) {
			showNewsletterPopUp(2000);
		}
	}
	newsletter.on('keyup', 'input[type="email"]', () => resetPopUpForm(newsletter));
}

if (!isMobile) {
	document.addEventListener('keyup', e => {
		e.key === 'Escape' && closePopUp();
	});
}

/* Menu
======================================== */
$('#menu-open').click(() => moveWrapper('menu'));
$('#aside-close').click(() => moveWrapper('content'));

/* Minicart
======================================== */
$('#trigger-cart, #cart-open').click(() => moveWrapper('cart'));
$('#mincart-close, .back-to-shop').click(() => {
	moveWrapper('content');
	$('#add-to-cart').removeClass('adding added');
})
$('aside').click(() => {
	if (window.innerWidth > 834 && $W.attr('data-visible') == 'cart') {
		moveWrapper('content');
		$('#add-to-cart').removeClass('adding added')
	}
})

/* Filters
======================================== */
$('.filter').click(function(){
	var val = $(this).data('filter');

	//Active/deactive filter
	$('.filter').removeClass('active')
	$('.filter[data-filter="'+val+'"]').addClass('active')

	//Hide projects
	$('.product').show()
	if(val != 'all'){
		$('.product:not([data-filter="'+val+'"])').hide()
	}

});

/* PDP Sections
======================================== */
$('#product-title, #product-price_wrapper').click(function(){
	var t = $('#trigger-specs');
	if(!t.hasClass('transition') && $specs.length){
		t.addClass('transition').toggleClass('active')
		$specs.slideToggle(speedx2, ease, function(){
			t.removeClass('transition')
		}).toggleClass('virgin')
	}
});

/* Lazy Loading
======================================== */
function lazyLoading(t){
	if(t.tagName == 'IMG'){
		t.src = t.dataset.src;
	}
	if(t.tagName == 'VIDEO'){
		var P = t.play();
		if(P !== undefined){
			P.catch(error => {
				if($(t).hasClass('gif')){
					t.classList.add('no-autoplay');
					t.controls = false;
				}else{
					t.classList.add('controls');
					t.controls = true;
				}
			});
		}
	}
	t.classList.remove('lazy');
}

/* Observer Functions
======================================== */
var L = [].slice.call(document.querySelectorAll('.lazy'));
if('IntersectionObserver' in window){
	let l = new IntersectionObserver(function(E, observer){
		E.forEach(function(e){
			if(e.isIntersecting){
				let t = e.target;
				lazyLoading(t)
				l.unobserve(t);
			}
		});
	});
	L.forEach(function(t){
		l.observe(t);
	});
}else{
	L.forEach(function(t){
		lazyLoading(t)
	});
}
